import React, { createContext } from "react";
const PrintReportContext = createContext();

export default PrintReportContext;
